import type { NextPage } from "next";
import React from "react";
import styles from "../../styles/Home.module.css";
import Image from "next/image";
import Linkdin from "image/linkedIn.png";
import Git from "image/github.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faWhatsapp,
  faTwitter,
  faInstagram,
  faLinkedinIn,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";

// const coffeeLookup: IconLookup = { prefix: "fab-solid", iconName: "fab-coffee" };
// const coffeeIconDefinition: IconDefinition = findIconDefinition(coffeeLookup);

const Footer: NextPage = () => {
  return (
    <>
      <div style={{ display: "flex" }}>
        <a
          href="https://github.com/KeyurItaliya"
          rel="noopener noreferrers"
          className="footer-card"
        >
          <FontAwesomeIcon icon={faGithub} />
        </a>
        <a
          href="https://www.linkedin.com/in/keyur-italiya"
          rel="noopener noreferrer"
          target="_blank"
          className="footer-card"
        >
          <FontAwesomeIcon icon={faLinkedinIn} />
          {/* <Image
            className={`carusal-image`}
            src={Linkdin}
            height="30"
            width="30"
            alt="man board"
          /> */}
        </a>
        <a
          href="https://www.instagram.com/keyur_italiya._"
          rel="noopener noreferrers"
          className="footer-card"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a
          href="https://wa.me/8140601664"
          rel="noopener noreferrers"
          className="footer-card"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
      <footer className={styles.footer}>
        <a
          href="https://keyur-profile.vercel.app"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: "10px" }}
        >
          Powered by{" "}
          {/* <Image src="/vercel.svg" alt="Vercel Logo" width={72} height={16} /> */}
          <span style={{ marginLeft: "5px" }}>
            <b> Keyur Italiya</b>
          </span>
        </a>
      </footer>
    </>
  );
};

export default Footer;
